Vue.component('news-list-component', {
    mixins: [ Mixins.queryString, Mixins.viewport, Mixins.lazyList ],
});
